module.exports = __webpack_public_path__ + "img/icon_mine_top.cd2f0c3e.png";